import { makeStyles } from 'tss-react/mui';

const useStylesImageFileContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  imageFileContainer: {
    marginLeft: 10,
    marginRight: 10,
    textAlign: 'left',
  },
  imageFileContainerWithSubBlock: {
    textAlign: 'inherit',
    marginLeft: 0,
    '& > div': {
      textAlign: 'left',
      marginTop: 10,
    },
  },
  imageFileContainerLargeImage: {
    marginLeft: 0,
    marginRight: 0,
    textAlign: 'center',
  },
  imageFileContainerNoOffset: {
    marginLeft: 0,
    marginRight: 0,
  },
}));

export default useStylesImageFileContainer;
